/**
 * Mirrors AUTO_CHARGE_FINALIZE_CONSENT_PREFIX in
 * packages/server/src/invoices/invoice-auto-charge.constants.ts, which the FE cannot import.
 */
const AUTO_CHARGE_CONSENT_PREFIX = 'cst_';

/**
 * Whether anything is on file that auto-charge could collect against.
 *
 * Deliberately dependency-free and primitive-only: the module that uses it reaches the shared
 * @received/pricing-model barrel, which drags in the PDF renderer and does not load under jsdom.
 * Keeping the rule here is what lets it be tested at all.
 *
 * Callers pass whichever shape they have. List projections answer the consent question server-side and
 * send `hasAutoChargeConsent`, so the prefix below is only consulted for the full Invoice, which embeds
 * the customer and carries the raw id.
 */
export const hasChargeableSource = ({
	paymentGatewayCustomerId,
	defaultPaymentMethodId,
	hasAutoChargeConsent,
}: {
	paymentGatewayCustomerId?: string | null;
	defaultPaymentMethodId?: string | null;
	hasAutoChargeConsent?: boolean | null;
}): boolean => !!paymentGatewayCustomerId || !!hasAutoChargeConsent || !!defaultPaymentMethodId?.startsWith(AUTO_CHARGE_CONSENT_PREFIX);
